import React from 'react';
import { Checkbox, makeStyles, withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import CountTextField from '../../../preorder/components/CountTextField';
import IMG from '../img';

export const StyledCheckbox = withStyles({
  root: {
    '&$checked': {
      color: '#000000',
    },
  },
  checked: {},
})(Checkbox);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    background: '#f2f2f2',
    position: 'relative',

    '&+&': {
      marginTop: theme.spacing(1.5),
    },
  },
  checkboxContainer: {
    flexShrink: 0,
    padding: theme.spacing(5, 0),
  },
  body: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: theme.spacing(2),
    paddingRight: theme.spacing(4),

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  footer: {
    display: 'none',
    width: 240,
    background: '#e9e9e9',

    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  footerItem: {
    alignItems: 'center',
    display: 'flex',
    flexBasis: 0,
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 0,
    justifyContent: 'center',
    padding: theme.spacing(1),
    position: 'relative',
    width: 120,
  },
  productInfo: {
    display: 'flex',

    [theme.breakpoints.up('sm')]: {
      flexGrow: 1,
      flexBasis: 0,
    },
  },
  pictureContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    marginLeft: theme.spacing(1),
  },
  removeButton: {
    outline: 'none',
    textDecoration: 'underline',
    border: 0,
    background: 'none',

    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  countContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(1),

    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  totalPrice: {
    color: '#a80000',
    fontWeight: 'bold',

    [theme.breakpoints.up('sm')]: {
      color: 'black',
    },
  },
  mask: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#ffffff',
    opacity: 0.5,
    zIndex: 10,
  },
}));

export default ({
  amount,
  checked,
  data,
  disabled,
  isReadOnly,
  onAddButtonClick,
  onCheckboxChange: propsOnCheckboxChange,
  onRemoveButtonClick,
  onSubButtonClick,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    name,
    provider,
    price,
    sellPrice,
    specs,
    images,
  } = data || {};

  const totalPrice = (sellPrice || price) * amount;
  const onCheckboxChange = (_e, newValue) => {
    propsOnCheckboxChange(newValue);
  };

  return (
    <div className={classes.root}>
      {!isReadOnly && (
        <div className={classes.checkboxContainer}>
          <StyledCheckbox
            onChange={onCheckboxChange}
            disabled={disabled}
            checked={checked}
          />
        </div>
      )}
      <div className={classes.body}>
        <div className={classes.productInfo}>
          <div className={classes.pictureContainer}>
            <IMG width="100px" src={images[0]} alt="" />
            {!isReadOnly && (
            <button
              className={classes.removeButton}
              onClick={onRemoveButtonClick}
              type="button"
            >
              {t('ec.remove_from_cart')}
            </button>
            )}
          </div>
          <div className={classes.infoContainer}>
            <div>{`【${provider}】${name}`}</div>
            {
              (specs || []).map(({ name: specName, value }) => (
                <div key={specName}>{`${specName}：${value}`}</div>
              ))
            }
            <div className={classes.countContainer}>
              {isReadOnly ? (
                <div>
                  {`${t('ec.purchase_amount')}： ${amount}`}
                </div>
              ) : (
                <div style={{ width: 130 }}>
                  <CountTextField
                    blackTonedStyle
                    defaultValue={amount}
                    minValue={1}
                    onChange={(value) => {
                      if (value - amount > 0) onAddButtonClick();
                      if (value - amount < 0) onSubButtonClick();
                    }}
                  />
                </div>
              )}
              <div className={classes.totalPrice}>{`$${totalPrice.toLocaleString('en-US')}`}</div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.footer}>
        <div className={classes.footerItem}>
          {isReadOnly
            ? amount
            : (
              <>
                <div>
                  <CountTextField
                    blackTonedStyle
                    defaultValue={amount}
                    minValue={1}
                    onChange={(value) => {
                      if (value - amount > 0) onAddButtonClick();
                      if (value - amount < 0) onSubButtonClick();
                    }}
                  />
                </div>
                <button
                  className={classes.removeButton}
                  onClick={onRemoveButtonClick}
                  style={{ position: 'absolute', bottom: 10, display: 'inline' }}
                  type="button"
                >
                  {t('ec.remove_from_cart')}
                </button>
              </>
            )}
        </div>
        <div className={classes.footerItem}>
          <div className={classes.totalPrice}>{`$${totalPrice.toLocaleString('en-US')}`}</div>
        </div>
      </div>
    </div>
  );
};
